import { BasicAuth } from '@instabox/lockers-update-common/types'

import fetch from '../fetch'

const BASIC_AUTH_STORAGE_KEY = 'BASIC_AUTH_STORAGE_KEY'

export function getCredentials(): BasicAuth | null {
  const credentials = window.localStorage.getItem(BASIC_AUTH_STORAGE_KEY)

  if (credentials === null) {
    return null
  }

  return JSON.parse(credentials)
}

export function setCredentials(username: string, password: string): void {
  window.localStorage.setItem(
    BASIC_AUTH_STORAGE_KEY,
    JSON.stringify({
      username,
      password,
    })
  )
}

export function clearCredentials(): void {
  window.localStorage.removeItem(BASIC_AUTH_STORAGE_KEY)
}

export async function areCredentialsValid(username: string, password: string): Promise<boolean> {
  const response = await fetch('/api/auth/validate', {
    headers: {
      Authorization: 'Basic ' + btoa(`${username}:${password}`),
    },
  })

  return response.ok
}
